import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Component, type ErrorInfo, type ReactNode} from 'react';
import {errorStore} from './ErrorStore';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

/** Shows a dialog when rendering fails or an uncaught error was reported to the {@link errorStore}. */
export class ErrorBoundary extends Component<Props, State> {

  public state: State = {hasError: errorStore.hasErrors};

  private unsubscribe?: () => void;

  public static getDerivedStateFromError(): State {
    return {hasError: true};
  }

  public componentDidMount() {
    this.unsubscribe = errorStore.subscribe(() => this.setState({hasError: true}));
  }

  public componentWillUnmount() {
    this.unsubscribe?.();
  }

  public componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(error, info.componentStack);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Dialog open={true}>
          <DialogTitle>Ein unerwarteter Fehler ist aufgetreten</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Bitte laden Sie die Seite neu. Falls das Problem bestehen bleibt, versuchen Sie es später erneut.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => window.location.reload()} color="primary">
              Neu laden
            </Button>
          </DialogActions>
        </Dialog>
      );
    }
    return this.props.children;
  }
}
